import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { normalizeSingleFilterFormData } from "@/helpers/request-helpers";
import ISalesProductPrice from "@/interfaces/sales-product-price.interfaces";
import salesProductPriceService from "@/services/sales-product-price.service";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetSalesProductPriceReturn =
  RequestsBaseReturn<PaginatedResponse<ISalesProductPrice> | null>;

export interface UseGetSalesProductPriceProps extends RequestPagination {
  filters: IFilter<ISalesProductPrice>[];
}

type GetSalesProductPriceSwrParams = [string, number, number, IFilter<ISalesProductPrice>[]];

const useGetSalesProductPrice = ({
  pageNumber,
  pageSize,
  filters,
}: UseGetSalesProductPriceProps): UseGetSalesProductPriceReturn => {
  const normalizedFilter = normalizeSingleFilterFormData(filters, "planName");

  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<PaginatedResponse<ISalesProductPrice>, Error, GetSalesProductPriceSwrParams>(
    [SWR_KEYS.getSalesProductPrice, pageNumber, pageSize, normalizedFilter],
    ([, _pageNumber, _pageSize, _filters]) =>
      salesProductPriceService.getAllSalesProductPrice(_filters, {
        pageNumber: _pageNumber,
        pageSize: _pageSize,
      }),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetSalesProductPrice;
